import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { CoreService } from '../../../service/core.service';
import { Login } from '../../../model/login.model';
import { Router } from "@angular/router";
import { SystemIdService } from 'src/app/system-id.service';

@Component({
  selector: 'app-fuji-billing-login',
  templateUrl: './fuji-billing-login.component.html',
  styleUrls: ['./fuji-billing-login.component.css']
})
export class FujiBillingLoginComponent implements OnInit {

  Accent: any;
  green: any;
  usr_email: any;
  usr_password: any;
  result = '';
  pageLoadingImg: boolean;
  company_code = '';
  codes: any;
  passwordVisible: boolean = false;
  hideCmpcodeInput: boolean = false;

  constructor(private systemIdService: SystemIdService, private apiService: ApiService, private coreService: CoreService, public router: Router) { }

  ngOnInit() {
    // $('#head-part').hide();
    if (this.coreService.getUserData('user_type')) {
      if (this.coreService.getUserData('user_type') == "PRICE CHECKER") {
        this.router.navigate(['/price_checker']);
      } else if (this.coreService.getUserData('user_type') == "AUDITOR") {
        this.router.navigate(['/report']);
      }
      else {
        this.router.navigate(['/master']);
      }
    }

    if (localStorage.getItem("fuji_bill_cmp_code")) {
      this.hideCmpcodeInput = true;
    }

    this.pageLoadingImg = false;

  }

  currentYear = new Date().getFullYear();

  loginFunct(form) {
    const system_Id = this.systemIdService.getSystemId();
    form.value.system_id = system_Id;
    if(localStorage.getItem("fuji_bill_cmp_code")){
      form.value.company_code = localStorage.getItem("fuji_bill_cmp_code");
    }
    
    this.pageLoadingImg = true;
    this.apiService.login(form.value).subscribe((res: Login) => {
      this.pageLoadingImg = false;
      if (res.error != null) {
        this.result = res.error;
        // console.log(this.result);
      }
      else {
        // console.log('res');
        // console.log(res);
        this.result = '';
        this.coreService.createfunct(form, this.result, "Login Success");
        document.cookie = "bquick=loggedin";
        localStorage.setItem("cmptoken", res.cmptoken);
        localStorage.setItem("auth_token", res.token);
        localStorage.removeItem("isBquickReloading");
        localStorage.setItem("fuji_bill_cmp_code", res.profile.cmpny);
        // localStorage.setItem("lcstg", CryptoJS.AES.encrypt(JSON.stringify(res.profile),'dKVFujk').toString());  
        this.coreService.setLocalStorage('lcstg', JSON.stringify(res.profile));
        this.coreService.setLocalStorage('urpg', JSON.stringify(res.usrPrvlg));
        this.apiService.getRates().subscribe((rescod: any) => {

          this.codes = rescod.rcd_code.split(';');
          this.coreService.setLocalStorage('rate_codes', JSON.stringify(this.codes));

        });

        this.apiService.getBlockTransactionSettings().subscribe((response: any) => {
          if (response.data == 1) {
            this.coreService.setLocalStorage('txnb', '1');
          } else {
            this.coreService.setLocalStorage('txnb', '0');
          }

        });


        if (res.usr_type == "PRICE CHECKER") {
          this.router.navigate(['/price_checker']);
        } else {
          // $('#head-part').show();
          if (res.profile.usr_username == 'auditor' || this.coreService.getUserData('user_type') == "AUDITOR") {

            this.router.navigate(['/report'])
          }
          else if (this.coreService.getUserData('user_type') == "SUPPORT") {
            this.router.navigate(['/support_login']);
          }
          else {
            this.router.navigate(['/master'])
          }

        }

        // custom print
        this.coreService.updatePrintTemplate();

      }

    });

  }

  togglePasswordVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
    const passwordInput = document.getElementById('password') as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = this.passwordVisible ? 'text' : 'password';
    }
  }

  changeCmpcode(){
    this.hideCmpcodeInput = false;
    localStorage.removeItem("fuji_bill_cmp_code"); 
  }

}
